import React from 'react';
import intl from 'react-intl-universal';

import { parseFen2Currency } from '@/utils/number';

import { BILL_TYPE_MAP } from '../config';
import commonStyles from '../common.module.scss';
import styles from './index.module.scss';

function Info({ info }) {
  return (
    <dl className={`${commonStyles['bill-block']} ${styles['reverse-bill-info']}`}>
      <dt className={commonStyles['bill-block-title']}>{intl.get('bill_reverse_wait_bill')}</dt>
      <dd>
        <label className="text-colon" style={{ minWidth: '12.5%' }}>
          {intl.get('app_constants_room_no')}
        </label>
        <span>{info.roomNo || '-'}</span>
      </dd>
      <dd>
        <label className="text-colon" style={{ minWidth: '12.5%' }}>
          {intl.get('bill_entry_bill_type')}
        </label>
        <span>{BILL_TYPE_MAP[info.postType] || '-'}</span>
      </dd>
      <dd>
        <label className="text-colon" style={{ minWidth: '12.5%' }}>
          {intl.get('bill_refound_res_bill_subject')}
        </label>
        <span>{info.subjectCodeName || '-'}</span>
      </dd>
      <dd>
        <label className="text-colon" style={{ minWidth: '12.5%' }}>
          {intl.get('bill_refound_res_detail')}
        </label>
        <span className={styles['reverse-detail']}>{info.detail || '-'}</span>
      </dd>
      <dd>
        <label className="text-colon" style={{ minWidth: '12.5%' }}>
          {intl.get('bill_credit_amount')}
        </label>
        <span>{parseFen2Currency(info.amount)}</span>
      </dd>
    </dl>
  );
}

export default Info;
